<template>
    <div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Form :ref="refName" :model="formModel" :rules="formRules" inline>
            <FormItem :label="_vm.$t('角色')" prop="group_name" class="layout50">
                <Input disabled v-model="formModel.group_name"></Input>
            </FormItem>
            <FormItem prop="menu_config" class="layout100">
                <div>{{_vm.$t('权限配置')}}</div>
                <div class="formHeight">
                    <Tree ref="interConfitTree" :data="interConfit" :render="renderContent" show-checkbox multiple
                          @on-check-change="checkChange" class="demo-tree-render"  :select-node="false" ></Tree>
                </div>
            </FormItem>
        </Form>
        <Modal
          v-model="showInterFace"
          title="接口配置"
          :mask-closable="false"
          :on-visible-change="visibleChange">
            <div slot="close"><Icon type="ios-close" @click="interfaceCancel" /></div>
            <div v-if="showInterFace">
                <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                    <Checkbox
                            :indeterminate="indeterminate"
                            :value="checkAll"
                            @click.prevent.native="handleCheckAll">全选
                    </Checkbox>
                </div>
                <CheckboxGroup :value="checkAllGroup" @on-change="checkAllGroupChange">
                    <Checkbox v-for="(item,index) in apilist" :key='item.api_code' :label="item.api_code" style="width:100%;">
                        {{item.res_desc}}
                    </Checkbox>
                </CheckboxGroup>
            </div>
            <div slot="footer">
                <Button @click="interfaceCancel">取消</Button>
                <Button type="primary" @click="interfaceOk">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
  import {renderFormMixins} from '@/mixins/renderFormMixins'
  import {recursiveMenu,deepcopy} from '@/libs/util'
  import {getgroup_permission} from '@/api/auth'
  export default {
    name: "addAccoutAuth",
    mixins: [renderFormMixins],
    data() {
      return {
        currCode:null,//当前code
        currSelectList: {},//当前所选的列
        apilist: [],//所属于的接口
        indeterminate: true,
        checkAll: false,
        checkAllGroup: [],//选中的项
        currInterFace: [],//当前选中的接口列表
        showInterFace: false,
        personMenuData: [],
        reqBase: {
          page: 1,
          page_size: 100
        },
        spinShow: false,
        interConfit: [],
        states: [
          {
            value: 0,
            label: "禁用"
          },
          {
            value: 1,
            label: "启用"
          }
        ],
        formModel: {
          admin_name: null,
          admin_real_name: null,
          menu_config:[],
          group_name:null
        },
        formRules: {}
      }
    },
    props: {
      _vm: {},
      edit: {},
      setData: {},
      personMenu: {},
      admin_id: {}
    },
    components: {},
    computed: {},
    methods: {
      handleCheckAll() {
        if (this.indeterminate) {
          this.checkAll = false;
        } else {
          this.checkAll = !this.checkAll;
        }
        this.indeterminate = false;
        if (this.checkAll) {
          let arr = [];
          for (let i in this.apilist) {
            let list = this.apilist[i];
            if (list.api_code) {
              arr.push(list.api_code);
            }
          }
          this.checkAllGroup.push(...arr);
        } else {
          this.checkAllGroup.splice(0);
        }
      },
      checkAllGroupChange(data) {
        let len=0
        for (let i in this.apilist){
          if (this.apilist) {
            len++
          }
        }
        if (data.length === len) {
          this.indeterminate = false;
          this.checkAll = true;
        } else if (data.length > 0) {
          this.indeterminate = true;
          this.checkAll = false;
        } else {
          this.indeterminate = false;
          this.checkAll = false;
        }
        this.checkAllGroup=data
      },
      showModal(b) {
        this.showInterFace = b;
      },
      /**
       *初始化接口配置
       */
      initInterFace() {

      },
      //接口取消
      interfaceCancel() {
        this.apilist.splice(0);//所属于的接口
        this.indeterminate = true;
        this.checkAll = false;
        this.checkAllGroup.splice(0);//选中的项
        this.showModal(false);
      },
      //接口保存
      interfaceOk() {
        let checkAllGroup = this.checkAllGroup
        let str = JSON.stringify(checkAllGroup)
        this.$set(this.currSelectList,this.currCode,JSON.parse(str))
        // this.currSelectList[this.currCode]=deepcopy(this.checkAllGroup);//当前所选
        this.showModal(false);
      },
      visibleChange(b) {
        if (b) {
          this.initInterFace();
        } else {
          this.interfaceCancel()
          this.showModal(false);
        }
      },
      renderContent(h, {root, node, data}) {
        let arr = [];
        // if (data.category === 1) {
        //   arr.push(h('Button', {
        //     props: Object.assign({}, this.buttonProps, {}),
        //     style: {
        //       marginRight: '8px'
        //     },
        //     on: {
        //       click: () => {
        //         this.selectInterFace(data)
        //       }
        //     }
        //   }, '配置接口'));
        // }
        return h('span', {
          'class':{'ivu-tree-title':true},
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('span', [
            h('Icon', {
              props: {
                type: 'ios-paper-outline'
              },
              style: {
                marginRight: '8px'
              }
            }),
            h('span', data.title)
          ]),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '32px'
            }
          }, arr),
        ]);
      },
      /**
       * 选择配置接口
       * @param data
       */
      selectInterFace(data) {
        //设置当前的code
        this.currCode=data.code;
        console.log(data.code)
        this.checkAllGroup.splice(0);//清空选择项
        this.apilist.splice(0);
        if (!this.currSelectList.hasOwnProperty(this.currCode)) {
          let arr=[]
          for (let i in data.api_codes){
            if (data.api_codes) {
              arr.push(data.api_codes[i])
            }
          }
          this.currSelectList[this.currCode]=arr;//当前所选
          for(let i=0;i<data.apilist.length;i++){
            let list=data.apilist[i]
            if(list.checked===1){
              this.checkAllGroup.push(list.api_code)
            }
          }
          
        } else {
          this.checkAllGroup.push(...this.currSelectList[this.currCode])
        }
        debugger
        this.checkAll = this.checkAllGroup.length === data.apilist.length;
        if (this.checkAll) {
          this.indeterminate=false
        } else {
          this.indeterminate=true
        }
        this.apilist.push(...data.apilist)
        this.showModal(true);
      },
      //选中菜单权限的change
      checkChange(checkData) {
        
        // let arr = [];
        // for (let i in checkData) {
        //   let list = checkData[i];
        //   if (list.nodeKey !== 0 && arr.indexOf(list.code)===-1) {
        //     arr.push(list.code)
        //   }
        // }
        // this.$set(this.formModel, 'menu_config', arr)
      },
      initMenu() {
        let vm = this;
        this.spinShow = true;
        getgroup_permission({group_id: this.admin_id}).then(res => {
          this.spinShow = false;
          if (res.result === 0) {
            this.interConfit = recursiveMenu(res.body);
            console.log('this.interConfit', this.interConfit);
            
          } else {
          }
        })
      }
    },
    mounted() {

    },
    created() {
      if (this.edit) {
        
        Object.assign(this.formModel, this.setData);
        //this.$set(this.formModel, 'menu_config', arr)

      }
      if (this.personMenu) {
        this.personMenuData.push(this.personMenu);
        this.$set(this.formModel, "parent_id", this.personMenu.personId);
      }
      this.initMenu();
    }
  }
</script>

<style scoped>
    .layout50, .layout100 {
        margin-bottom: 15px;
    }

    .layout50 {
        width: calc(50% - 12px);
    }

    .layout100 {
        width: calc(100% - 12px);
    }

    .formHeight {
        height: 400px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>
